import script from "./HistorialItems.vue?vue&type=script&setup=true&lang=js"
export * from "./HistorialItems.vue?vue&type=script&setup=true&lang=js"

import "./HistorialItems.vue?vue&type=style&index=0&id=59604adf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59604adf"]])

export default __exports__